// src/components/Tickets/TextInputModal.jsx
import React, { useState, useEffect } from 'react';
import Modal from './Modal';

export default function TextInputModal({
  isOpen,
  onClose,
  onSubmit,
  label = 'Input',
  placeholder = '',
  defaultValue = '',
  submitText = 'Submit',
}) {
  const [value, setValue] = useState(defaultValue || '');
  const [error, setError] = useState('');

  useEffect(() => {
    setValue(defaultValue || '');
    setError('');
  }, [defaultValue, isOpen]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const text = (value ?? "").toString().trim(); // ✅ handles null/number/etc.

    if (!text) {
      setError(`${label} is required.`);
      return;
    }

    onSubmit(text);
  };

  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label" htmlFor="textInputModalField">{label}</label>
          <input
            id="textInputModalField"
            type="text"
            className={`form-control ${error ? 'is-invalid' : ''}`}
            value={value}
            onChange={(e) => { setValue(e.target.value); setError(''); }}
            placeholder={placeholder}
            maxLength={255}
            autoFocus
          />
          {error && <div className="invalid-feedback">{error}</div>}
        </div>
        <div className="d-flex justify-content-end gap-2">
          <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
          <button type="submit" className="btn btn-primary">{submitText}</button>
        </div>
      </form>
    </Modal>
  );
}
